// @flow

import type { Action } from './store.type';
import { FilterTreeType } from 'src/models/filter-tree';

export const GET_FILTER_TREE_REQUEST = 'GET_FILTER_TREE_REQUEST';
type GET_FILTER_TREE_REQUEST_TYPE = 'GET_FILTER_TREE_REQUEST';

export const GET_FILTER_TREE_SUCCESS = 'GET_FILTER_TREE_SUCCESS';
type GET_FILTER_TREE_SUCCESS_TYPE = 'GET_FILTER_TREE_SUCCESS';

export const GET_FILTER_TREE_FAILURE = 'GET_FILTER_TREE_FAILURE';
type GET_FILTER_TREE_FAILURE_TYPE = 'GET_FILTER_TREE_FAILURE';

export const CREATE_FILTER_TREE_REQUEST = 'CREATE_FILTER_TREE_REQUEST';
type CREATE_FILTER_TREE_REQUEST_TYPE = 'CREATE_FILTER_TREE_REQUEST';

export const CREATE_FILTER_TREE_SUCCESS = 'CREATE_FILTER_TREE_SUCCESS';
type CREATE_FILTER_TREE_SUCCESS_TYPE = 'CREATE_FILTER_TREE_SUCCESS';

export const CREATE_FILTER_TREE_FAILURE = 'CREATE_FILTER_TREE_FAILURE';
type CREATE_FILTER_TREE_FAILURE_TYPE = 'CREATE_FILTER_TREE_FAILURE';

export const UPDATE_FILTER_TREE_REQUEST = 'UPDATE_FILTER_TREE_REQUEST';
type UPDATE_FILTER_TREE_REQUEST_TYPE = 'UPDATE_FILTER_TREE_REQUEST';

export const UPDATE_FILTER_TREE_SUCCESS = 'UPDATE_FILTER_TREE_SUCCESS';
type UPDATE_FILTER_TREE_SUCCESS_TYPE = 'UPDATE_FILTER_TREE_SUCCESS';

export const UPDATE_FILTER_TREE_FAILURE = 'UPDATE_FILTER_TREE_FAILURE';
type UPDATE_FILTER_TREE_FAILURE_TYPE = 'UPDATE_FILTER_TREE_FAILURE';

export const GET_ALL_FILTER_OPTIONS_REQUEST = 'GET_ALL_FILTER_OPTIONS_REQUEST';
type GET_ALL_FILTER_OPTIONS_REQUEST_TYPE = 'GET_ALL_FILTER_OPTIONS_REQUEST';

export const GET_ALL_FILTER_OPTIONS_SUCCESS = 'GET_ALL_FILTER_OPTIONS_SUCCESS';
type GET_ALL_FILTER_OPTIONS_SUCCESS_TYPE = 'GET_ALL_FILTER_OPTIONS_SUCCESS';

export const GET_ALL_FILTER_OPTIONS_FAILURE = 'GET_ALL_FILTER_OPTIONS_FAILURE';
type GET_ALL_FILTER_OPTIONS_FAILURE_TYPE = 'GET_ALL_FILTER_OPTIONS_FAILURE';

type FilterTreeSuccess = {
  data: FilterTreeType
};

type FilterTreeFailure = {
  error: any
};

type FilterOptionsSuccess = {
  data: { filterOptionId: string, label: string },
  total: number
};

type GetFilterTreeRequestAction = Action<GET_FILTER_TREE_REQUEST_TYPE, null>;

type GetFilterTreeSuccessAction = Action<GET_FILTER_TREE_SUCCESS_TYPE, FilterTreeSuccess>;

type GetFilterTreeFailureAction = Action<GET_FILTER_TREE_FAILURE_TYPE, FilterTreeFailure>;

type CreateFilterTreeRequestAction = Action<CREATE_FILTER_TREE_REQUEST_TYPE, null>;

type CreateFilterTreeSuccessAction = Action<CREATE_FILTER_TREE_SUCCESS_TYPE, FilterTreeSuccess>;

type CreateFilterTreeFailureAction = Action<CREATE_FILTER_TREE_FAILURE_TYPE, FilterTreeFailure>;

type UpdateFilterTreeRequestAction = Action<UPDATE_FILTER_TREE_REQUEST_TYPE, null>;

type UpdateFilterTreeSuccessAction = Action<UPDATE_FILTER_TREE_SUCCESS_TYPE, FilterTreeSuccess>;

type UpdateFilterTreeFailureAction = Action<UPDATE_FILTER_TREE_FAILURE_TYPE, FilterTreeFailure>;

type GetAllFilterOptionsRequestAction = Action<GET_ALL_FILTER_OPTIONS_REQUEST_TYPE, null>;

type GetAllFilterOptionsSuccessAction = Action<
  GET_ALL_FILTER_OPTIONS_SUCCESS_TYPE,
  FilterOptionsSuccess
>;

type GetAllFilterOptionsFailureAction = Action<
  GET_ALL_FILTER_OPTIONS_FAILURE_TYPE,
  FilterTreeFailure
>;

export type FilterTreeAction =
  | GetFilterTreeRequestAction
  | GetFilterTreeSuccessAction
  | GetFilterTreeFailureAction
  | CreateFilterTreeRequestAction
  | CreateFilterTreeSuccessAction
  | CreateFilterTreeFailureAction
  | UpdateFilterTreeRequestAction
  | UpdateFilterTreeSuccessAction
  | UpdateFilterTreeFailureAction
  | GetAllFilterOptionsRequestAction
  | GetAllFilterOptionsSuccessAction
  | GetAllFilterOptionsFailureAction;

export type FilterTreeState = {
  loading: boolean,
  success: boolean,
  error: any,
  filterTree: FilterTreeType | {},
  allFilterOptions: Array<{ filterOptionId: string, label: string }> | {},
  scheduleSyncInfo: { waitSyncAt: number, scheduleSyncIn: number, scheduleSyncAfter: number }
};
